import { useMsal } from '@azure/msal-react';

export const useCurrentUser = () => {
  const { accounts } = useMsal();

  const currentAccount = accounts[0];
  
  const userEmail = currentAccount?.username || 
                    currentAccount?.idTokenClaims?.preferred_username || 
                    currentAccount?.idTokenClaims?.email || 
                    '';
  
  const displayName = currentAccount?.name || 
                      currentAccount?.idTokenClaims?.name || 
                      '';
  
  const objectId = currentAccount?.idTokenClaims?.oid || 
                   currentAccount?.idTokenClaims?.sub || 
                   null;

  return {
    email: userEmail,
    displayName: displayName,
    objectId: objectId,
    account: currentAccount,
    idTokenClaims: currentAccount?.idTokenClaims || {},
    
    isAuthenticated: accounts.length > 0 && !!userEmail,
  };
};

